var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:`bto-sb-col-${_vm.colcount}`,class:['bto-sb-base-col', `bto-sb-col-${_vm.colcount}`, _vm.coldata.settings.customClass],attrs:{"id":`bto-sb-col-${_vm.coldata.id}`}},[_c(_vm.useSticky ? 'div' : 'empty-component',{ref:"stickyCol",tag:"component",class:{
      'bto-sb-col-sticky': true,
      'bto-sb-col-fixed': _vm.sticky && _vm.fixed,
      'bto-sb-col-abs': _vm.sticky && !_vm.fixed,
    },style:(_vm.getTopStyle)},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }